import { useQuasar } from 'quasar';
import { computed } from 'vue';

export function useDeviceSize() {
  const $q = useQuasar();

  // Меньше брейкпоинте $bp-mobile
  const isMobile = computed(() => {
    if ($q.screen.width !== 0) {
      return $q.screen.width ? $q.screen.width < 600 : false;
    }
    // SSR проверка
    return !!$q.platform.is.mobile;
  });
  // В диапазоне от $bp-mobile до $bp-tablet
  const isLaptop = computed(() =>
    $q.screen.width ? $q.screen.width <= 1024 && $q.screen.width >= 600 : false
  );

  const MoreLaptop = computed(() =>
    $q.screen.width ? $q.screen.width <= 1024 && $q.screen.width >= 600 : false
  );
  // Больше $bp-tablet
  const isDesktop = computed(() => {
    if ($q.screen.width !== 0) {
      return $q.screen.width ? $q.screen.width > 1024 : false;
    }
    // SSR проверка
    return !!$q.platform.is.desktop;
  });

  const isMdScreenSize = computed(() => {
    return $q.screen.md;
  });

  const getScreenWidth = computed(() => $q.screen.width);

  return {
    isMobile,
    isLaptop,
    MoreLaptop,
    isDesktop,
    getScreenWidth,
    isMdScreenSize
  };
}
